/**
 * Promo Pill 1 — rounded badge ("Admissions closing soon"), a Header section variant.
 *
 * Stored on the shared `header` table like every other Header variant: text, colours
 * and sticky reuse Header 6's featured_pill_* columns, plus three columns of its own.
 * One pill per placement, so there is no metadata table (`showTable: false`).
 */

export const PROMO_PILL_1_CONSTANTS = {
  PROMO_PILL_FIELDS_CONFIG: [
    {
      fieldName: "featured_pill_text",
      label: "Pill text",
      value: "Admissions closing soon",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Admissions closing soon",
      required: false,
      defaultValue: "Admissions closing soon",
    },
    {
      fieldName: "featured_pill_bg_color",
      label: "Pill fill",
      value: "#F4F217",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F4F217",
    },
    {
      fieldName: "featured_pill_border_color",
      label: "Pill outer ring",
      value: "#F4F217",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F4F217",
    },
    {
      fieldName: "featured_pill_text_color",
      label: "Pill text colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "featured_pill_sticky",
      // The pill is not viewport-pinned: on, it overlays the top of the next widget
      // and scrolls away with the page; off, it takes its own row in the flow.
      label: "Float over the next widget",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "featured_pill_enable_animation",
      label: "Breathing animation",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "featured_pill_link_url",
      label: "Link (optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://… — leave blank for plain text",
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
